const create = {
  path: 'create',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftWeChat/found/create'], resolve)
}

export default create
